export const montserratStyle = {
  fontFamily: 'Montserrat',
}

export const titleStyle = {
  ...montserratStyle,
  fontWeight: 700 as const,
  fontSize: '1rem', // text-base
}

export const tabsStyle = {
  minHeight: 'auto',
}

export const tabStyle = {
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'Montserrat',
  textTransform: 'none' as const,
  minHeight: 'auto',
  padding: '8px 16px',
}

export const explanationStyle = {
  ...montserratStyle,
  fontSize: '0.875rem', // text-sm
  color: '#4B5563', // text-gray-600
}

export const errorTextStyle = {
  ...montserratStyle,
  color: '#DC2626', // text-red-600
}

export const emptyTextStyle = {
  ...montserratStyle,
  color: '#4B5563', // text-gray-600
}
